import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.applications.assign', {
        url: '/assign',
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupApplicationsAssign'
        },
        resolve: {
            applications,
        },
    });
}

/** @ngInject */
function applications(companyId, groupId, GroupsResource) {
    return GroupsResource.getAssignableApplicationsForGroup(companyId, groupId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/applications/assign/assign-group-to-application.state.js